import React from 'react';
/* eslint-disable */
export default {
  accidents: (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <path
        d="M18.4,9.9L19,8.3c0-0.9-0.4-1.5-1.4-1.7L6.3,4.1c-1-0.2-1.5,0.5-1.8,1.3L3.1,9.7C3,9.9,3,10.1,3,10.3v9.2
	C3,19.8,3.2,20,3.5,20h2C5.8,20,6,19.8,6,19.5V18l12,1v0.5c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5V15l-0.6-1.6L18.4,9.9z
	 M6.1,5.8c0-0.1,0.2-0.2,0.4-0.2l10.7,2.4c0.1,0,0.2,0.1,0.3,0.2l-0.8,1.8l1.8,2.8L4.7,10L6.1,5.8z M6.5,15C5.7,15,5,14.3,5,13.5
	S5.7,12,6.5,12S8,12.7,8,13.5S7.3,15,6.5,15z M17.5,16c-0.8,0-1.5-0.7-1.5-1.5c0-0.4,0.1-0.7,0.4-1L17,14h1v1l0.5,0.7
	C18.2,15.9,17.9,16,17.5,16z"
      />
    </svg>
  ),
  'archers-arrow': (className, styles) => (
    <svg className={className} viewBox="0 0 24 24">
      <path
        style={{
          textIndent: '0',
          textAlign: 'start',
          lineHeight: 'normal',
          textTransform: 'none',
          blockProgression: 'tb',
          InkscapeFontSpecification: 'Bitstream Vera Sans',
          ...styles,
        }}
        d="M 22 2 L 17 3 L 17 5.5625 L 9.5625 13 L 7 13 L 2 18 L 4.5625 18 L 2.28125 20.28125 L 3.71875 21.71875 L 6 19.4375 L 6 22 L 11 17 L 11 14.4375 L 18.4375 7 L 21 7 L 22 2 z"
        color="#000"
        overflow="visible"
        fontFamily="Bitstream Vera Sans"
      />
    </svg>
  ),
  accidents: (className, styles) => (
    <svg
      className={className}
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <path
        d="M18.4,9.9L19,8.3c0-0.9-0.4-1.5-1.4-1.7L6.3,4.1c-1-0.2-1.5,0.5-1.8,1.3L3.1,9.7C3,9.9,3,10.1,3,10.3v9.2
	C3,19.8,3.2,20,3.5,20h2C5.8,20,6,19.8,6,19.5V18l12,1v0.5c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5V15l-0.6-1.6L18.4,9.9z
	 M6.1,5.8c0-0.1,0.2-0.2,0.4-0.2l10.7,2.4c0.1,0,0.2,0.1,0.3,0.2l-0.8,1.8l1.8,2.8L4.7,10L6.1,5.8z M6.5,15C5.7,15,5,14.3,5,13.5
	S5.7,12,6.5,12S8,12.7,8,13.5S7.3,15,6.5,15z M17.5,16c-0.8,0-1.5-0.7-1.5-1.5c0-0.4,0.1-0.7,0.4-1L17,14h1v1l0.5,0.7
	C18.2,15.9,17.9,16,17.5,16z"
      />
    </svg>
  ),
  'calendar-add': (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <g>
        <path
          d="M19,4h-1V2h-2v2H8V2H6v2H5C3.9,4,3,4.9,3,6v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20H5V9h14V20
     z"
        />
        <polygon points="14.1,18 14.9,18 14.9,15.9 17,15.9 17,15.1 14.9,15.1 14.9,13 14.1,13 14.1,15.1 12,15.1 12,15.9 14.1,15.9 	" />
      </g>
    </svg>
  ),
  'calendar-today': (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <path
        d="M16,2v2H8V2H6v2H5C3.9,4,3,4.9,3,6v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2h-1V2H16z M19,20H5V9h14V20z
    M7,13v5h5v-5H7z"
      />
    </svg>
  ),
  'calendar-tomorrow': (className, styles) => (
    <svg
      className={className}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      style={styles}
    >
      <path
        d="M 6 2 L 6 4 L 5 4 C 3.9 4 3 4.9 3 6 L 3 20 C 3 21.1 3.9 22 5 22 L 19 22 C 20.1 22 21 21.1 21 20 L 21 6 C 21 4.9 20.1 4 19 4 L 18 4 L 18 2 L 16 2 L 16 4 L 8 4 L 8 2 L 6 2 z M 5 9 L 19 9 L 19 20 L 5 20 L 5 9 z M 12 13 L 12 18 L 17 18 L 17 13 L 12 13 z"
        fillRule="evenodd"
      />
    </svg>
  ),
  facebook: (className, styles) => (
    <svg className={className} viewBox="0 0 26 26" style={styles}>
      <path d="M21.125,0H4.875C2.182,0,0,2.182,0,4.875v16.25C0,23.818,2.182,26,4.875,26h16.25 C23.818,26,26,23.818,26,21.125V4.875C26,2.182,23.818,0,21.125,0z M20.464,14.002h-2.433v9.004h-4.063v-9.004h-1.576v-3.033h1.576 V9.037C13.969,6.504,15.021,5,18.006,5h3.025v3.022h-1.757c-1.162,0-1.238,0.433-1.238,1.243l-0.005,1.703h2.764L20.464,14.002z" />
    </svg>
  ),
  'chevron-circle-right': (className, styles) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      className={className}
      y="0px"
      viewBox="0 0 32 32"
      style={{ enableBackground: 'new 0 0 32 32', ...styles }}
    >
      <g>
        <path
          d="M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16s16-7.2,16-16C32,7.2,24.8,0,16,0z M16,31C7.7,31,1,24.3,1,16C1,7.7,7.7,1,16,1
		s15,6.7,15,15C31,24.3,24.3,31,16,31z"
        />
        <polygon points="12.6,10.7 17.9,16 12.6,21.3 13.4,22 19.4,16 13.4,10 	" />
      </g>
    </svg>
  ),
  facebook: (className, styles) => (
    <svg
      className={className}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      style={styles}
    >
      <path d="M21.125,0H4.875C2.182,0,0,2.182,0,4.875v16.25C0,23.818,2.182,26,4.875,26h16.25 C23.818,26,26,23.818,26,21.125V4.875C26,2.182,23.818,0,21.125,0z M20.464,14.002h-2.433v9.004h-4.063v-9.004h-1.576v-3.033h1.576 V9.037C13.969,6.504,15.021,5,18.006,5h3.025v3.022h-1.757c-1.162,0-1.238,0.433-1.238,1.243l-0.005,1.703h2.764L20.464,14.002z" />
    </svg>
  ),
  instagram: (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <path
        d="M6.7,0C3,0,0,3,0,6.7v10.7C0,21,3,24,6.7,24h10.7c3.7,0,6.7-3,6.7-6.7V6.7C24,3,21,0,17.3,0H6.7z M20,2.7
   c0.7,0,1.3,0.6,1.3,1.3S20.7,5.3,20,5.3S18.7,4.7,18.7,4S19.3,2.7,20,2.7z M12,5.3c3.7,0,6.7,3,6.7,6.7s-3,6.7-6.7,6.7
   s-6.7-3-6.7-6.7S8.3,5.3,12,5.3z M12,8c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S14.2,8,12,8z"
      />
    </svg>
  ),
  'live-stream': (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      style={{ enableBackground: 'new 0 0 32 32', ...styles }}
    >
      <g>
        <polygon points="2.4,6.1 0,6.1 0,17.6 7.5,17.6 7.5,15.7 2.4,15.7 	" />
        <rect x="9" y="6.1" width="2.4" height="11.6" />
        <polygon points="17.9,14.8 15.2,6.1 12.6,6.1 16.6,17.6 19.1,17.6 23.1,6.1 20.5,6.1 	" />
        <polygon points="26.6,15.7 26.6,12.6 31.2,12.6 31.2,10.8 26.6,10.8 26.6,8 32,8 32,6.1 24.2,6.1 24.2,17.6 32,17.6 32,15.7 	" />
        <polygon fill="none" points="21.8,23.7 23.3,23.7 22.5,21.5 	" />
        <path
          fill="none"
          d="M12.6,21h-1v1.8h1c0.2,0,0.3,0,0.4-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.4
		c0-0.3-0.1-0.5-0.2-0.7C13.1,21.1,12.9,21,12.6,21z"
        />
        <path
          d="M1.6,21.1C1.7,21,1.8,21,1.9,20.9c0.1,0,0.3-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1C2.9,21,3,21,3,21.1c0.1,0.1,0.1,0.2,0.2,0.3
		c0,0.1,0.1,0.2,0.1,0.3h1.2c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.3-0.7-0.4C3,20,2.7,19.9,2.3,19.9
		c-0.3,0-0.6,0-0.9,0.1c-0.3,0.1-0.5,0.2-0.7,0.3c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2-0.2,0.4-0.2,0.7c0,0.3,0.1,0.5,0.2,0.7
		c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.1,0.5,0.2,0.8,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0.1,0.3,0.1,0.3,0.2
		C3.2,23.9,3.2,24,3.2,24s0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1C2.7,25,2.5,25,2.4,25
		c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.1-0.5H0c0,0.2,0,0.4,0.1,0.6
		c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.2,0.3,0.4,0.4c0.2,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.4,0.1,0.6,0.1
		c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.5-0.2,0.7-0.3s0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2,0-0.5-0.1-0.6
		c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.5-0.2-0.8-0.3c-0.4-0.1-0.7-0.2-0.9-0.4c-0.2-0.1-0.3-0.3-0.3-0.5
		c0-0.1,0-0.2,0.1-0.3C1.5,21.2,1.5,21.1,1.6,21.1z"
        />
        <polygon points="4.9,21 6.7,21 6.7,25.9 7.9,25.9 7.9,21 9.7,21 9.7,20 4.9,20 	" />
        <path
          d="M14.1,23.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2,0.1-0.4,0.1-0.6c0-0.3,0-0.5-0.1-0.8
		c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.1-0.4-0.3-0.7-0.3C13.2,20,12.9,20,12.6,20h-2.2v5.9h1.2v-2.1h1l1.1,2.1H15v-0.1l-1.3-2.4
		C13.9,23.3,14,23.3,14.1,23.2z M13.5,22.2c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.3,0.1-0.4,0.1h-1V21h1
		c0.3,0,0.6,0.1,0.7,0.2c0.2,0.2,0.2,0.4,0.2,0.7C13.5,22,13.5,22.1,13.5,22.2z"
        />
        <polygon
          points="16.9,23.3 19.2,23.3 19.2,22.4 16.9,22.4 16.9,21 19.6,21 19.6,20 15.7,20 15.7,25.9 19.6,25.9 19.6,24.9 
		16.9,24.9 	"
        />
        <path d="M22,20l-2.2,5.9h1.3l0.4-1.2h2.1l0.4,1.2h1.3L23.1,20H22z M21.8,23.7l0.7-2.2l0.7,2.2H21.8z" />
        <polygon
          points="30.4,20 28.9,24.3 27.4,20 25.8,20 25.8,25.9 27,25.9 27,24.3 26.9,21.5 28.5,25.9 29.3,25.9 30.9,21.5 30.8,24.3 
		30.8,25.9 32,25.9 32,20 	"
        />
      </g>
    </svg>
  ),
  magnifier: (className, styles) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 1024 1024"
      className={className}
      style={styles}
    >
      <g id="icomoon-ignore" />
      <path d="M266.4 664.6c-50.2-69-80.2-153.8-80.2-245.8 0-231.2 187.6-418.8 418.8-418.8s419 187.6 419 419-187.6 419-419 419c-92 0-176.6-30-245.6-80.2l-266.4 266.2c0 0-93 0-93-93l266.4-266.4zM279.2 419c0 180 145.8 325.8 325.8 325.8s325.8-145.8 325.8-325.8-145.8-326-325.8-326-325.8 146-325.8 326z" />
    </svg>
  ),
  'partly-cloudy-rain': (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 48 48"
      enableBackground="new 0 0 48 48"
      style={styles}
    >
      <polygon
        fill="#FF9800"
        points="24,18 27,15 24,12 24,7 19,7 16,4 13,7 8,7 8,12 5,15 8,18 8,23 13,23 16,26 19,23 24,23 "
      />
      <path
        fill="#FFEB3B"
        d="M10,15c0,3.3,2.7,6,6,6s6-2.7,6-6s-2.7-6-6-6S10,11.7,10,15"
      />
      <path
        fill="#BBDEFB"
        d="M37.9,20.1C38,19.7,38,19.4,38,19c0-3.9-3.1-7-7-7c-2.8,0-5.2,1.6-6.3,4c-1-1.2-2.5-2-4.2-2
	c-3,0-5.5,2.5-5.5,5.5c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0c-3.3,0-6,2.7-6,6s2.7,6,6,6c0,0,0.1,0,0.1,0c0,0,0,0,0,0H37c3.3,0,6-2.7,6-6
	C43,23,40.8,20.5,37.9,20.1z"
      />
      <path
        fill="#2196F3"
        d="M36.9,40.2c-1.1,1.1-3,1.1-4.1,0c-1.1-1.1-1.1-3,0-4.1C34,34.9,39,34,39,34S38.1,39,36.9,40.2z M28,38
	c0,0-5,0.9-6.2,2.1c-1.1,1.1-1.1,3,0,4.1c1.1,1.1,3,1.1,4.1,0C27.1,43,28,38,28,38z M18,34c0,0-5,0.9-6.2,2.1c-1.1,1.1-1.1,3,0,4.1
	c1.1,1.1,3,1.1,4.1,0C17.1,39,18,34,18,34z"
      />
    </svg>
  ),
  patrols: (className, styles) => (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      style={styles}
    >
      <path
        style={{
          textIndent: '0',
          textAlign: 'start',
          lineHeight: 'normal',
          textTransform: 'none',
          blockProgression: 'tb',
          InkscapeFontSpecification: 'Bitstream Vera Sans',
        }}
        d="M 11 1 L 11 4 L 13 4 L 13 1 L 11 1 z M 4.90625 3.5 L 3.5 4.90625 L 5.28125 6.71875 L 6.71875 5.28125 L 4.90625 3.5 z M 19.09375 3.5 L 17.28125 5.28125 L 18.71875 6.71875 L 20.5 4.90625 L 19.09375 3.5 z M 8.6875 6 C 7.2208333 6 6.0017222 7.0851389 5.71875 8.5 L 5.71875 8.53125 L 5.71875 8.5625 L 4.125 20 L 3 20 L 3 22 L 3.84375 22 L 20.15625 22 L 21 22 L 21 20 L 19.875 20 L 18.1875 8.59375 C 18.186504 8.58379 18.1886 8.572429 18.1875 8.5625 C 18.025444 7.097834 16.769291 6 15.3125 6 L 8.6875 6 z M 8.6875 8 L 15.3125 8 C 15.845833 8 16.166696 8.2919569 16.21875 8.8125 L 16.21875 8.84375 L 16.25 9 L 9.40625 9 C 9.20625 9 9.00625 9.20625 8.90625 9.40625 L 7.4375 20 L 6.15625 20 L 7.6875 8.90625 C 7.8045278 8.3211111 8.1541667 8 8.6875 8 z M 1 11 L 1 13 L 4 13 L 4 11 L 1 11 z M 20 11 L 20 13 L 23 13 L 23 11 L 20 11 z"
      />
    </svg>
  ),
  'play-circle': (className, styles) => (
    <svg
      x="0"
      y="0"
      className={className}
      viewBox="0, 0, 48, 39"
      style={styles}
    >
      <g id="Layer_1">
        <path d="M19.1,7.437 C19.474,7.437 19.798,7.587 20.082,7.798 L33.637,16.781 C34.31,17.034 34.799,17.7 34.799,18.499 C34.799,19.099 34.511,19.608 34.092,19.943 L20.184,29.129 C19.884,29.387 19.515,29.563 19.1,29.563 C18.136,29.563 17.356,28.74 17.356,27.719 L17.356,9.281 C17.356,8.262 18.136,7.437 19.1,7.437 z" />
        <path d="M24,0.062 C34.183,0.062 42.438,8.317 42.438,18.5 C42.438,28.683 34.183,36.938 24,36.938 C13.817,36.938 5.562,28.683 5.562,18.5 C5.562,8.317 13.817,0.062 24,0.062 z M24,2.17 C14.981,2.17 7.67,9.481 7.67,18.5 C7.67,27.519 14.981,34.83 24,34.83 C33.019,34.83 40.33,27.519 40.33,18.5 C40.33,9.481 33.019,2.17 24,2.17 z" />
      </g>
    </svg>
  ),
  play: (className, styles) => (
    <svg
      className={className}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      style={styles}
    >
      <path d="M 7 5 L 7 19 L 19 12 L 7 5 z" />
    </svg>
  ),
  radars: (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <path
        d="M7,2C5.9,2,5,2.9,5,4v10h14V4c0-1.1-0.9-2-2-2H7z M12,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S9.8,4,12,4z M12,5.5
   c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S13.4,5.5,12,5.5z M4,15v2h5.3L6,22h2.5l3.3-5h0.3l3.3,5H18l-3.3-5H20v-2H4
   z"
      />
    </svg>
  ),
  restrictions: (className, styles) => (
    <svg
      viewBox="0 0 24 24"
      className={className}
      enableBackground="new 0 0 24 24"
      style={styles}
    >
      <path d="M 11.90625 2 C 11.30625 2 10.79375 2.30625 10.59375 2.90625 L 9.8125 5 L 11.5 5 L 12 4 C 12.1 3.8 12.3 3.59375 12.5 3.59375 L 18.40625 3.59375 C 18.60625 3.59375 18.90625 3.7 18.90625 4 L 20.1875 7 L 14.40625 7 L 15.1875 9 L 18 9 C 18.2 8.4 18.80625 8 19.40625 8 C 20.30625 8 21 8.7 21 9.5 C 21 9.6 21.00625 9.80625 20.90625 9.90625 C 21.00625 10.10625 21.1875 10.3 21.1875 10.5 L 21.90625 12.3125 L 21.90625 7.5 C 21.90625 7.2 21.7875 6.89375 21.6875 6.59375 L 20.1875 2.90625 C 20.0875 2.30625 19.59375 2 19.09375 2 L 11.90625 2 z M 4.90625 6 C 4.40625 6 3.8875 6.30625 3.6875 6.90625 L 2.1875 10.59375 C 2.0875 10.89375 2 11.2 2 11.5 L 2 17.5 C 2 17.8 2.2 18 2.5 18 L 4.5 18 C 4.8 18 5 17.8 5 17.5 L 5 16 L 8 16 L 8 15.5 C 8 15.1 8.0875 14.6125 8.1875 14.3125 L 9.5 11 L 3.6875 11 C 3.6875 11 4.6 8.8 5 8 C 5.1 7.8 5.3 7.59375 5.5 7.59375 L 11.40625 7.59375 C 11.60625 7.59375 11.90625 7.7 11.90625 8 L 12.3125 9 L 14.09375 9 L 13.1875 6.90625 C 13.0875 6.30625 12.59375 6 12.09375 6 L 4.90625 6 z M 11.8125 10 C 11.2125 10 10.7 10.30625 10.5 10.90625 L 9 14.59375 C 9.1 14.89375 9 15.2 9 15.5 L 9 21.5 C 9 21.8 9.2 22 9.5 22 L 11.5 22 C 11.8 22 12 21.8 12 21.5 L 12 20 L 19 20 L 19 21.5 C 19 21.8 19.2 22 19.5 22 L 21.5 22 C 21.8 22 22 21.8 22 21.5 L 22 15.5 C 22 15.2 21.9125 14.89375 21.8125 14.59375 L 20.3125 10.90625 C 20.1125 10.40625 19.6 10 19 10 L 11.8125 10 z M 12.5 11.59375 L 18.40625 11.59375 C 18.60625 11.59375 18.90625 11.7 18.90625 12 L 20.1875 15 L 10.59375 15 C 10.69375 15 11.6 12.8 12 12 C 12.1 11.8 12.3 11.59375 12.5 11.59375 z M 4.5 12 C 5.3 12 6 12.7 6 13.5 C 6 14.3 5.3 15 4.5 15 C 3.7 15 3 14.3 3 13.5 C 3 12.7 3.7 12 4.5 12 z M 11.5 16 C 12.3 16 13 16.7 13 17.5 C 13 18.3 12.3 19 11.5 19 C 10.7 19 10 18.3 10 17.5 C 10 16.7 10.7 16 11.5 16 z M 19.5 16 C 20.3 16 21 16.7 21 17.5 C 21 18.3 20.3 19 19.5 19 C 18.7 19 18 18.3 18 17.5 C 18 16.7 18.7 16 19.5 16 z" />
    </svg>
  ),
  share: (className, styles) => (
    <svg
      x="0px"
      y="0px"
      className={className}
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <path fill="none" d="M0,0h24v24H0V0z" />
      <path
        d="M18,16.1c-0.8,0-1.4,0.3-2,0.8l-7.1-4.2C9,12.5,9,12.2,9,12s0-0.5-0.1-0.7L16,7.2C16.5,7.7,17.2,8,18,8c1.7,0,3-1.3,3-3
	s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.5,0.1,0.7L8,9.8C7.5,9.3,6.8,9,6,9c-1.7,0-3,1.3-3,3s1.3,3,3,3c0.8,0,1.5-0.3,2-0.8l7.1,4.2
	c-0.1,0.2-0.1,0.4-0.1,0.6c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S19.6,16.1,18,16.1z"
      />
    </svg>
  ),
  snow: (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      width="48px"
      height="48px"
      viewBox="0 0 48 48"
      enableBackground="new 0 0 48 48"
      style={styles}
    >
      <g>
        <circle fill="#BBDEFB" cx="29.5" cy="13.5" r="8.5" />
        <circle fill="#BBDEFB" cx="37" cy="21.893" r="7" />
        <circle fill="#BBDEFB" cx="11" cy="22" r="7" />
        <circle fill="#BBDEFB" cx="17.5" cy="14.5" r="6.5" />
        <circle fill="#BBDEFB" cx="25" cy="19.893" r="7" />
        <path
          fill="#BBDEFB"
          d="M7,25c0,2.209,1.791,4,4,4h25c2.209,0,4-1.791,4-4v-1c0-2.209-1.791-4-4-4H11c-2.209,0-4,1.791-4,4V25z"
        />
      </g>
      <g>
        <rect x="23" y="34" fill="#2196F3" width="2" height="9" />

        <rect
          x="23"
          y="33.999"
          transform="matrix(-0.5071 0.8619 -0.8619 -0.5071 69.3514 37.3369)"
          fill="#2196F3"
          width="2"
          height="9"
        />

        <rect
          x="23.001"
          y="34"
          transform="matrix(0.4897 0.8719 -0.8719 0.4897 45.8148 -1.2789)"
          fill="#2196F3"
          width="1.998"
          height="9"
        />
        <rect x="10" y="31" fill="#2196F3" width="2" height="9" />

        <rect
          x="10"
          y="30.999"
          transform="matrix(-0.5067 0.8621 -0.8621 -0.5067 47.1784 44.0037)"
          fill="#2196F3"
          width="2"
          height="9"
        />

        <rect
          x="10.001"
          y="31"
          transform="matrix(0.4897 0.8719 -0.8719 0.4897 36.5653 8.5247)"
          fill="#2196F3"
          width="1.998"
          height="9"
        />
        <rect x="36" y="31" fill="#2196F3" width="2" height="9" />

        <rect
          x="35.999"
          y="30.998"
          transform="matrix(-0.5069 0.862 -0.862 -0.5069 86.3539 21.6007)"
          fill="#2196F3"
          width="2"
          height="9"
        />

        <rect
          x="36"
          y="31"
          transform="matrix(0.4897 0.8719 -0.8719 0.4897 49.8327 -14.144)"
          fill="#2196F3"
          width="1.998"
          height="9.001"
        />
      </g>
    </svg>
  ),
  'speaker-mute': (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <path d="M12,3L6,9H2v6h4l6,6V3z" />
    </svg>
  ),
  speaker: (className, styles) => (
    <svg
      className={className}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      style={styles}
    >
      <path d="M 12 3 L 6 9 L 2 9 L 2 15 L 6 15 L 12 21 L 12 3 z M 14 3.09375 L 14 5.09375 C 17.1875 5.5625 19.670654 8.1394043 19.96875 11.34375 C 19.988623 11.557373 20 11.78125 20 12 C 20 15.5 17.4 18.40625 14 18.90625 L 14 20.90625 C 18.5 20.40625 22 16.6 22 12 C 22 7.4 18.5 3.59375 14 3.09375 z M 14 7.09375 L 14 9.1875 C 15.2 9.5875 16 10.7 16 12 C 16 13.3 15.2 14.4125 14 14.8125 L 14 16.90625 C 16.3 16.40625 18 14.4 18 12 C 18 9.6 16.3 7.59375 14 7.09375 z" />
    </svg>
  ),
  sun: (className, styles) => (
    <svg
      className={className}
      style={styles}
      x="0px"
      y="0px"
      width="48px"
      height="48px"
      viewBox="0 0 48 48"
      enableBackground="new 0 0 48 48"
    >
      <g>
        <rect x="11" y="11" fill="#FF9800" width="26" height="26" />
        <rect
          x="11.272"
          y="11.272"
          transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.9411 24)"
          fill="#FF9800"
          width="25.456"
          height="25.456"
        />
      </g>
      <path
        fill="#FFEB3B"
        d="M13,24c0,6.077,4.923,11,11,11c6.076,0,11-4.923,11-11s-4.924-11-11-11C17.923,13,13,17.923,13,24"
      />
    </svg>
  ),
  twitter: (className, styles) => (
    <svg
      className={className}
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24', ...styles }}
    >
      <path
        d="M21.6,0H2.4C1.1,0,0,1.1,0,2.4v19.2C0,22.9,1.1,24,2.4,24h19.2c1.3,0,2.4-1.1,2.4-2.4V2.4C24,1.1,22.9,0,21.6,0z M18.7,8.2
	c0,0.1,0,0.2,0,0.5c0,4.6-3.5,9.8-9.8,9.8c-1.9,0-3.7-0.6-5.3-1.6c0.2,0,0.6,0,0.8,0c1.6,0,3.1-0.6,4.3-1.4c-1.6,0-2.8-1.1-3.2-2.4
	c0.2,0,0.5,0.1,0.6,0.1c0.4,0,0.6,0,1-0.1c-1.6-0.4-2.8-1.7-2.8-3.4l0,0c0.5,0.2,1,0.4,1.6,0.5c-1-0.8-1.6-1.8-1.6-3
	c0-0.6,0.1-1.2,0.5-1.7C6.5,7.6,9,9,11.9,9.1c0-0.2-0.1-0.5-0.1-0.8c0-1.9,1.6-3.5,3.5-3.5c1,0,1.9,0.4,2.5,1.1
	c0.8-0.1,1.6-0.5,2.2-0.8c-0.2,0.8-0.8,1.4-1.6,1.9c0.7-0.1,1.3-0.2,2-0.6C19.9,7.1,19.3,7.7,18.7,8.2z"
      />
    </svg>
  ),
  user: (className, styles) => (
    <svg
      className={className}
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
      style={styles}
    >
      <path d="M 12 4 C 9.790861 4 8 5.790861 8 8 C 8 10.209139 9.790861 12 12 12 C 14.209139 12 16 10.209139 16 8 C 16 5.790861 14.209139 4 12 4 z M 12 14 C 5.9 14 4 18 4 18 L 4 20 L 20 20 L 20 18 C 20 18 18.1 14 12 14 z" />
    </svg>
  ),
  kosiceonline: (className, styles) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="93.869"
      height="24"
      viewBox="0 0 93.869 24"
      className={className}
      style={styles}
    >
      <g
        id="Group_30"
        data-name="Group 30"
        transform="translate(-64.7 -64.064)"
      >
        <g
          id="Group_28"
          data-name="Group 28"
          transform="translate(95.477 69.146)"
        >
          <path
            id="Path_46"
            data-name="Path 46"
            d="M207.908,94.56a6.5,6.5,0,0,1,.545-2.6,6.818,6.818,0,0,1,1.55-2.23,7.138,7.138,0,0,1,2.316-1.5,7.25,7.25,0,0,1,2.718-.517,7.376,7.376,0,0,1,2.761.521,6.837,6.837,0,0,1,4.4,6.454,6.591,6.591,0,0,1-.541,2.627,6.731,6.731,0,0,1-1.536,2.215,7.218,7.218,0,0,1-2.33,1.507,7.375,7.375,0,0,1-2.751.512,7.246,7.246,0,0,1-2.732-.526,7.047,7.047,0,0,1-2.3-1.493,6.767,6.767,0,0,1-2.1-4.966Zm2.038.067a5.069,5.069,0,0,0,.383,1.952,5,5,0,0,0,1.1,1.646,4.824,4.824,0,0,0,1.641,1.105,5.267,5.267,0,0,0,3.943.009,4.917,4.917,0,0,0,1.65-1.115,5.055,5.055,0,0,0,1.493-3.6,4.965,4.965,0,0,0-.383-1.938,5.261,5.261,0,0,0-1.129-1.67A4.926,4.926,0,0,0,217,89.9a5.038,5.038,0,0,0-1.962-.388,4.926,4.926,0,0,0-1.928.392,5.38,5.38,0,0,0-1.68,1.12,4.775,4.775,0,0,0-1.1,1.636A5.163,5.163,0,0,0,209.946,94.627Z"
            transform="translate(-207.908 -87.709)"
            fill="#161615"
          />
          <path
            id="Path_47"
            data-name="Path 47"
            d="M277.931,102.075V88.688H279.6l8.813,10.392V88.688h1.9v13.387h-1.7l-8.785-10.4v10.4Z"
            transform="translate(-262.882 -88.478)"
            fill="#161615"
          />
          <path
            id="Path_48"
            data-name="Path 48"
            d="M342.746,102.075V88.688h1.895v11.665h6.373v1.722Z"
            transform="translate(-313.768 -88.478)"
            fill="#161615"
          />
          <path
            id="Path_49"
            data-name="Path 49"
            d="M382.4,102.075V88.688h1.914v13.387Z"
            transform="translate(-344.902 -88.478)"
            fill="#161615"
          />
          <path
            id="Path_50"
            data-name="Path 50"
            d="M398.55,102.075V88.688h1.665l8.813,10.392V88.688h1.9v13.387h-1.7l-8.784-10.4v10.4Z"
            transform="translate(-357.579 -88.478)"
            fill="#161615"
          />
          <path
            id="Path_51"
            data-name="Path 51"
            d="M463.1,102.075V88.688h8.048v1.7h-6.153v4.057h5.981v1.732h-5.981v4.172h6.354v1.722Z"
            transform="translate(-408.254 -88.478)"
            fill="#161615"
          />
        </g>
        <g
          id="Group_29"
          data-name="Group 29"
          transform="translate(64.7 64.064)"
        >
          <path
            id="Path_52"
            data-name="Path 52"
            d="M76.7,64.064a12,12,0,1,0,12,12A12,12,0,0,0,76.7,64.064Zm7.484,6.46.2,1.819L77.47,73.1l-.2-1.819ZM69.225,81.687l-1.034-9.4,1.827-.2,1.034,9.4Zm6.023-.663-3.069-4.13-.849,1.081-.267-2.427,2.861-3.9,2.553-.281L73.34,75.424l4.364,5.33Zm2.438-5.947,4.795-.527.2,1.819-4.795.527Zm.617,5.611-.2-1.819,6.914-.761.2,1.819Z"
            transform="translate(-64.7 -64.064)"
            fill="#e1001e"
            fill-rule="evenodd"
          />
        </g>
      </g>
    </svg>
  ),
  kosiceonlineInactive: (className, styles) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="93.869"
      height="24"
      viewBox="0 0 93.869 24"
      className={className}
      style={styles}
    >
      <g
        id="Group_30"
        data-name="Group 30"
        transform="translate(-64.7 -64.064)"
      >
        <g
          id="Group_28"
          data-name="Group 28"
          transform="translate(95.477 69.146)"
        >
          <path
            id="Path_46"
            data-name="Path 46"
            d="M207.908,94.56a6.5,6.5,0,0,1,.545-2.6,6.818,6.818,0,0,1,1.55-2.23,7.138,7.138,0,0,1,2.316-1.5,7.25,7.25,0,0,1,2.718-.517,7.376,7.376,0,0,1,2.761.521,6.837,6.837,0,0,1,4.4,6.454,6.591,6.591,0,0,1-.541,2.627,6.731,6.731,0,0,1-1.536,2.215,7.218,7.218,0,0,1-2.33,1.507,7.375,7.375,0,0,1-2.751.512,7.246,7.246,0,0,1-2.732-.526,7.047,7.047,0,0,1-2.3-1.493,6.767,6.767,0,0,1-2.1-4.966Zm2.038.067a5.069,5.069,0,0,0,.383,1.952,5,5,0,0,0,1.1,1.646,4.824,4.824,0,0,0,1.641,1.105,5.267,5.267,0,0,0,3.943.009,4.917,4.917,0,0,0,1.65-1.115,5.055,5.055,0,0,0,1.493-3.6,4.965,4.965,0,0,0-.383-1.938,5.261,5.261,0,0,0-1.129-1.67A4.926,4.926,0,0,0,217,89.9a5.038,5.038,0,0,0-1.962-.388,4.926,4.926,0,0,0-1.928.392,5.38,5.38,0,0,0-1.68,1.12,4.775,4.775,0,0,0-1.1,1.636A5.163,5.163,0,0,0,209.946,94.627Z"
            transform="translate(-207.908 -87.709)"
            fill="#ccc"
          />
          <path
            id="Path_47"
            data-name="Path 47"
            d="M277.931,102.075V88.688H279.6l8.813,10.392V88.688h1.9v13.387h-1.7l-8.785-10.4v10.4Z"
            transform="translate(-262.882 -88.478)"
            fill="#ccc"
          />
          <path
            id="Path_48"
            data-name="Path 48"
            d="M342.746,102.075V88.688h1.895v11.665h6.373v1.722Z"
            transform="translate(-313.768 -88.478)"
            fill="#ccc"
          />
          <path
            id="Path_49"
            data-name="Path 49"
            d="M382.4,102.075V88.688h1.914v13.387Z"
            transform="translate(-344.902 -88.478)"
            fill="#ccc"
          />
          <path
            id="Path_50"
            data-name="Path 50"
            d="M398.55,102.075V88.688h1.665l8.813,10.392V88.688h1.9v13.387h-1.7l-8.784-10.4v10.4Z"
            transform="translate(-357.579 -88.478)"
            fill="#ccc"
          />
          <path
            id="Path_51"
            data-name="Path 51"
            d="M463.1,102.075V88.688h8.048v1.7h-6.153v4.057h5.981v1.732h-5.981v4.172h6.354v1.722Z"
            transform="translate(-408.254 -88.478)"
            fill="#ccc"
          />
        </g>
        <g
          id="Group_29"
          data-name="Group 29"
          transform="translate(64.7 64.064)"
        >
          <path
            id="Path_52"
            data-name="Path 52"
            d="M76.7,64.064a12,12,0,1,0,12,12A12,12,0,0,0,76.7,64.064Zm7.484,6.46.2,1.819L77.47,73.1l-.2-1.819ZM69.225,81.687l-1.034-9.4,1.827-.2,1.034,9.4Zm6.023-.663-3.069-4.13-.849,1.081-.267-2.427,2.861-3.9,2.553-.281L73.34,75.424l4.364,5.33Zm2.438-5.947,4.795-.527.2,1.819-4.795.527Zm.617,5.611-.2-1.819,6.914-.761.2,1.819Z"
            transform="translate(-64.7 -64.064)"
            fill="#ccc"
            fill-rule="evenodd"
          />
        </g>
      </g>
    </svg>
  ),
  radiokosice: (className, styles) => (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 85.2 24"
      className={className}
      style={{ ...styles, enableBackground: 'new 0 0 85.2 24' }}
    >
      <g id="Group_33" transform="translate(-64.7 -219.932)">
        <g id="Group_31" transform="translate(95.531 222.011)">
          <path
            id="Path_53"
            style={{
              fillRule: 'evenodd',
              clipRule: 'evenodd',
              fill: '#161615',
            }}
            d="M5.5,12.6l-0.2-0.2c-0.6-0.8-0.7-0.9-1.8-0.9H1.7v4.1l0,0v1H0V3.2h5.1c1.1,0,2.2,0.4,3.1,1.1
    			  C9.1,5,9.5,6.1,9.5,7.2l0,0l0,0l0,0c0,0.3,0,0.6-0.1,0.9C9.4,8.4,9.3,8.6,9.2,8.9c-0.5,1.1-1.5,2-2.7,2.2l3.9,5.2l0.1,0.2H8.5l0,0
    			  L5.5,12.6L5.5,12.6z M47.5,16.7L47.5,16.7c-1.9,0-3.6-0.7-4.9-2.1c-1.2-1.3-1.9-3-1.9-4.8l0,0l0,0l0,0c0-0.7,0.1-1.5,0.3-2.2
    			  c0.1-0.3,0.2-0.7,0.4-1c0.8-1.7,2.2-2.9,4-3.4l0,0c0.1,0,0.2-0.1,0.3-0.1l0,0c0.1,0,0.2,0,0.3-0.1C46.5,3,47,3,47.5,3l0,0
    			  c0.5,0,1,0,1.5,0.2C51.8,3.7,54,6,54.3,8.9l0,0v0l0,0c0,0.1,0,0.1,0,0.1s0,0.1,0,0.1l0,0c0,0.2,0,0.4,0,0.7l0,0
    			  c0,1.8-0.7,3.5-1.9,4.8C51.1,16,49.4,16.8,47.5,16.7L47.5,16.7L47.5,16.7z M47.5,4.5L47.5,4.5c-1.4,0-2.7,0.5-3.6,1.5
    			  c-0.9,1-1.4,2.4-1.4,3.7l0,0c0,1.4,0.5,2.7,1.4,3.8c0.9,1,2.3,1.6,3.6,1.6l0,0c1.4,0,2.7-0.5,3.6-1.5c0.9-1,1.4-2.4,1.4-3.7l0,0
    			  l0,0l0,0c0-1.4-0.5-2.7-1.4-3.8C50.2,5.1,48.9,4.5,47.5,4.5L47.5,4.5L47.5,4.5z M38,16.4V3.2h1.7v13.3H38l0,0l0,0V16.4L38,16.4z
    			   M29.7,16.5h-4.7v-4.4l0,0V3.2h4.7c0.5,0,1,0,1.5,0.1c0.5,0.1,0.9,0.2,1.4,0.4c2.2,0.8,3.8,2.8,4.1,5.2v0l0,0c0,0.1,0,0.1,0,0.1
    			  s0,0.1,0,0.1c0,0.2,0,0.4,0,0.7l0,0c0,1.8-0.7,3.5-2,4.8C33.4,15.9,31.6,16.6,29.7,16.5L29.7,16.5L29.7,16.5z M29.7,4.8h-3v10.2h3
    			  c1.4,0,2.8-0.5,3.9-1.5c0.9-1,1.5-2.3,1.4-3.6l0,0l0,0l0,0c0-1.4-0.5-2.7-1.4-3.6C32.6,5.3,31.2,4.7,29.7,4.8L29.7,4.8L29.7,4.8z
    			   M24.4,16.5h-1.6l0-0.1l-1.6-3.4h-7l-1.6,3.4l0,0.1h-1.8l0.1-0.2l6-13.2l0-0.1H17l1.4,0h0.1l0,0.1l6,13.2l0.1,0.2L24.4,16.5z
    			   M17.7,5.2l-2.8,6.3h5.6L17.7,5.2z M19.8,0.2l-1.1,2l0,0.1h-1.4L17.4,2l0.9-2l0-0.1h1.7L19.8,0.2L19.8,0.2z M5,4.8H1.7v5.1l3.2,0
    			  l0,0c0.7,0,1.5-0.2,2-0.7C7.5,8.7,7.8,8,7.8,7.3l0,0c0-0.7-0.3-1.4-0.8-1.8C6.4,5,5.7,4.7,5,4.8L5,4.8L5,4.8z"
          />
        </g>
        <g id="Group_32" transform="translate(64.7 219.932)">
          <path
            id="Path_54"
            style={{
              fillRule: 'evenodd',
              clipRule: 'evenodd',
              fill: '#E1001E',
            }}
            d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,6.5l0.2,1.8L12.8,9
    			  l-0.2-1.8L19.5,6.5z M4.5,17.6l-1-9.4L5.3,8l1,9.4L4.5,17.6z M10.5,17l-3.1-4.1l-0.8,1.1l-0.3-2.4l2.9-3.9l2.6-0.3l-3.1,4.1
    			  l4.4,5.3L10.5,17z M13,11l4.8-0.5l0.2,1.8l-4.8,0.5L13,11z M13.6,16.6l-0.2-1.8l6.9-0.8l0.2,1.8L13.6,16.6z"
          />
        </g>
      </g>
    </svg>
  ),
  radiokosiceInactive: (className, styles) => (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 85.2 24"
      className={className}
      style={{ ...styles, enableBackground: 'new 0 0 85.2 24' }}
    >
      <g id="Group_33" transform="translate(-64.7 -219.932)">
        <g id="Group_31" transform="translate(95.531 222.011)">
          <path
            id="Path_53"
            style={{
              fillRule: 'evenodd',
              clipRule: 'evenodd',
              fill: '#ccc',
            }}
            d="M5.5,12.6l-0.2-0.2c-0.6-0.8-0.7-0.9-1.8-0.9H1.7v4.1l0,0v1H0V3.2h5.1c1.1,0,2.2,0.4,3.1,1.1
    			  C9.1,5,9.5,6.1,9.5,7.2l0,0l0,0l0,0c0,0.3,0,0.6-0.1,0.9C9.4,8.4,9.3,8.6,9.2,8.9c-0.5,1.1-1.5,2-2.7,2.2l3.9,5.2l0.1,0.2H8.5l0,0
    			  L5.5,12.6L5.5,12.6z M47.5,16.7L47.5,16.7c-1.9,0-3.6-0.7-4.9-2.1c-1.2-1.3-1.9-3-1.9-4.8l0,0l0,0l0,0c0-0.7,0.1-1.5,0.3-2.2
    			  c0.1-0.3,0.2-0.7,0.4-1c0.8-1.7,2.2-2.9,4-3.4l0,0c0.1,0,0.2-0.1,0.3-0.1l0,0c0.1,0,0.2,0,0.3-0.1C46.5,3,47,3,47.5,3l0,0
    			  c0.5,0,1,0,1.5,0.2C51.8,3.7,54,6,54.3,8.9l0,0v0l0,0c0,0.1,0,0.1,0,0.1s0,0.1,0,0.1l0,0c0,0.2,0,0.4,0,0.7l0,0
    			  c0,1.8-0.7,3.5-1.9,4.8C51.1,16,49.4,16.8,47.5,16.7L47.5,16.7L47.5,16.7z M47.5,4.5L47.5,4.5c-1.4,0-2.7,0.5-3.6,1.5
    			  c-0.9,1-1.4,2.4-1.4,3.7l0,0c0,1.4,0.5,2.7,1.4,3.8c0.9,1,2.3,1.6,3.6,1.6l0,0c1.4,0,2.7-0.5,3.6-1.5c0.9-1,1.4-2.4,1.4-3.7l0,0
    			  l0,0l0,0c0-1.4-0.5-2.7-1.4-3.8C50.2,5.1,48.9,4.5,47.5,4.5L47.5,4.5L47.5,4.5z M38,16.4V3.2h1.7v13.3H38l0,0l0,0V16.4L38,16.4z
    			   M29.7,16.5h-4.7v-4.4l0,0V3.2h4.7c0.5,0,1,0,1.5,0.1c0.5,0.1,0.9,0.2,1.4,0.4c2.2,0.8,3.8,2.8,4.1,5.2v0l0,0c0,0.1,0,0.1,0,0.1
    			  s0,0.1,0,0.1c0,0.2,0,0.4,0,0.7l0,0c0,1.8-0.7,3.5-2,4.8C33.4,15.9,31.6,16.6,29.7,16.5L29.7,16.5L29.7,16.5z M29.7,4.8h-3v10.2h3
    			  c1.4,0,2.8-0.5,3.9-1.5c0.9-1,1.5-2.3,1.4-3.6l0,0l0,0l0,0c0-1.4-0.5-2.7-1.4-3.6C32.6,5.3,31.2,4.7,29.7,4.8L29.7,4.8L29.7,4.8z
    			   M24.4,16.5h-1.6l0-0.1l-1.6-3.4h-7l-1.6,3.4l0,0.1h-1.8l0.1-0.2l6-13.2l0-0.1H17l1.4,0h0.1l0,0.1l6,13.2l0.1,0.2L24.4,16.5z
    			   M17.7,5.2l-2.8,6.3h5.6L17.7,5.2z M19.8,0.2l-1.1,2l0,0.1h-1.4L17.4,2l0.9-2l0-0.1h1.7L19.8,0.2L19.8,0.2z M5,4.8H1.7v5.1l3.2,0
    			  l0,0c0.7,0,1.5-0.2,2-0.7C7.5,8.7,7.8,8,7.8,7.3l0,0c0-0.7-0.3-1.4-0.8-1.8C6.4,5,5.7,4.7,5,4.8L5,4.8L5,4.8z"
          />
        </g>
        <g id="Group_32" transform="translate(64.7 219.932)">
          <path
            id="Path_54"
            style={{
              fillRule: 'evenodd',
              clipRule: 'evenodd',
              fill: '#ccc',
            }}
            d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,6.5l0.2,1.8L12.8,9
    			  l-0.2-1.8L19.5,6.5z M4.5,17.6l-1-9.4L5.3,8l1,9.4L4.5,17.6z M10.5,17l-3.1-4.1l-0.8,1.1l-0.3-2.4l2.9-3.9l2.6-0.3l-3.1,4.1
    			  l4.4,5.3L10.5,17z M13,11l4.8-0.5l0.2,1.8l-4.8,0.5L13,11z M13.6,16.6l-0.2-1.8l6.9-0.8l0.2,1.8L13.6,16.6z"
          />
        </g>
      </g>
    </svg>
  ),
  tvkosice: (className, styles) => (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 54.3 24"
      style="enable-background:new 0 0 54.3 24;"
      className={className}
      style={styles}
    >
      <g id="Group_36" transform="translate(-64.7 -386.221)">
        <g id="Group_34" transform="translate(95.531 391.492)">
          <path
            id="Path_55"
            style={{ fill: '#ccc' }}
            d="M4.9,13.4V1.8H0V0h11.8v1.7H6.9v11.7L4.9,13.4z"
          />
          <path
            id="Path_56"
            style={{ fill: '#ccc' }}
            d="M16.9,13.5L11,0h2l4.2,9.6L21.5,0h2l-6,13.5H16.9z"
          />
        </g>
        <g id="Group_35" transform="translate(64.7 386.221)">
          <path
            id="Path_57"
            style={{
              fillRule: 'evenodd',
              clipRule: 'evenodd',
              fill: '#ccc',
            }}
            d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,6.5l0.2,1.8L12.8,9
			l-0.2-1.8L19.5,6.5z M4.5,17.6l-1-9.4L5.3,8l1,9.4L4.5,17.6z M10.5,17l-3.1-4.1l-0.8,1.1l-0.3-2.4l2.9-3.9l2.6-0.3l-3.1,4.1
			l4.4,5.3L10.5,17z M13,11l4.8-0.5l0.2,1.8l-4.8,0.5L13,11z M13.6,16.6l-0.2-1.8l6.9-0.8l0.2,1.8L13.6,16.6z"
          />
        </g>
      </g>
    </svg>
  ),
  runwayRun: (className, styles) => (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 86.9 24"
      className={className}
      style={{ ...styles, enableBackground: 'new 0 0 86.9 24' }}
    >
      <g id="Group_24" transform="translate(-64.7 -552.509)">
        <g id="Group_22" transform="translate(64.7 552.509)">
          <path
            id="Path_25"
            style={{ fillRule: 'evenodd', clipRule: evenodd, fill: '#E1001E' }}
            d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,6.5l0.2,1.8L12.8,9
          l-0.2-1.8L19.5,6.5z M4.5,17.6l-1-9.4L5.3,8l1,9.4L4.5,17.6z M10.5,17l-3.1-4.1l-0.8,1.1l-0.3-2.4l2.9-3.9l2.6-0.3l-3.1,4.1
          l4.4,5.3L10.5,17z M13,11l4.8-0.5l0.2,1.8l-4.8,0.5L13,11z M13.6,16.6l-0.2-1.8l6.9-0.8l0.2,1.8L13.6,16.6z"
          />
        </g>
        <g id="Group_23" transform="translate(105.056 555.813)">
          <path
            id="Path_26"
            style={{ fill: '#161615' }}
            d="M0,7.6V0h2.2C2.9,0,3.5,0.2,4,0.5c0.4,0.4,0.7,1,0.6,1.5c0,0.4-0.1,0.9-0.3,1.2
          C4,3.6,3.6,3.9,3.2,4c0.1,0.1,0.3,0.2,0.4,0.3C3.7,4.4,3.9,4.6,4,4.8l1.9,2.8H4.6l-1.3-2C3,5.2,2.7,4.8,2.3,4.5
          C2,4.3,1.7,4.2,1.4,4.2H1.1v3.4L0,7.6z M1.1,3.3H2c0.4,0,0.8-0.1,1.1-0.3c0.5-0.5,0.5-1.3,0-1.8C2.8,1,2.4,0.9,2,0.9H1.1V3.3z"
          />
          <path
            id="Path_27"
            style={{ fill: '#161615' }}
            d="M6.3,0h1.1v4.4c0,0.3,0,0.7,0.1,1c0,0.2,0.1,0.4,0.3,0.5c0.2,0.3,0.5,0.5,0.8,0.6
          c0.3,0.1,0.7,0.2,1.1,0.2c0.6,0,1.1-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.4V0h1.1v4.9c0,0.8-0.3,1.6-0.9,2.1
          c-0.7,0.6-1.5,0.8-2.4,0.8C9,7.8,8.5,7.7,8,7.5C7.5,7.3,7.1,7,6.8,6.6C6.6,6.3,6.5,6.1,6.4,5.8C6.3,5.3,6.3,4.9,6.3,4.4L6.3,0z"
          />
          <path
            id="Path_28"
            style={{ fill: '#161615' }}
            d="M14.5,7.6V0h0.9l5,5.9V0h1.1v7.6h-1l-5-5.9v5.9H14.5z"
          />
          <path
            id="Path_29"
            style={{ fill: '#161615' }}
            d="M25,7.7L22.1,0h1.1l1.9,5.2L27.2,0h0.7l2,5.2L31.8,0h1.1l-2.9,7.7h-0.2l-2.3-5.9l-2.3,5.9H25z"
          />
          <path
            id="Path_30"
            style={{ fill: '#161615' }}
            d="M32.5,7.6L35.8,0h0.8l3.4,7.6h-1.1l-1-2.2h-3.3l-1,2.2H32.5z M35,4.4h2.4l-1.2-2.8L35,4.4z"
          />
          <path
            id="Path_31"
            style={{ fill: '#161615' }}
            d="M42.3,7.6V3.8L39.4,0h1.3l2.2,2.9L45.2,0h1.3l-3.1,3.9v3.8L42.3,7.6z"
          />
          <path
            id="Path_32"
            style={{ fill: '#161615' }}
            d="M0,18.4v-7.6h2.2c0.6,0,1.3,0.2,1.8,0.5c0.4,0.4,0.7,1,0.6,1.5c0,0.4-0.1,0.9-0.3,1.2
          c-0.3,0.3-0.7,0.6-1.1,0.7c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.2,0.3,0.4,0.4,0.6l1.9,2.8H4.6l-1.3-2c-0.3-0.4-0.6-0.8-1-1.2
          C2,15.1,1.7,15,1.4,15H1.1v3.4L0,18.4z M1.1,14.1H2c0.4,0,0.8-0.1,1.1-0.3c0.5-0.5,0.5-1.3,0-1.8c-0.3-0.2-0.8-0.3-1.2-0.3H1.1
          V14.1z"
          />
          <path
            id="Path_33"
            style={{ fill: '#161615' }}
            d="M6.3,10.7h1.1v4.4c0,0.3,0,0.7,0.1,1c0,0.2,0.1,0.4,0.3,0.5c0.2,0.3,0.5,0.5,0.8,0.6
          c0.3,0.1,0.7,0.2,1.1,0.2c0.6,0,1.1-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.4v-4.9h1.1v4.9c0,0.8-0.3,1.6-0.9,2.1
          c-0.7,0.6-1.5,0.8-2.4,0.8c-0.5,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.9c-0.2-0.2-0.3-0.5-0.4-0.8c-0.1-0.4-0.1-0.9-0.1-1.3
          L6.3,10.7z"
          />
          <path
            id="Path_34"
            style={{ fill: '#161615' }}
            d="M14.5,18.4v-7.6h0.9l5,5.9v-5.9h1.1v7.6h-1l-5-5.9v5.9H14.5z"
          />
        </g>
        <path
          id="Path_35"
          style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#161615' }}
          d="M96.7,565.1c0,0,0,0.1,0,0.1s0,0.1,0,0.1c0,0.2,0,0.5,0,0.7l0,0.1c0,0,0,0,0.1,0c0.1,0,0,0,0,0
        c0.1,0,0.1,0,0.2,0c0,0,0.1,0.7,0.1,0.7c0,0.1,0.1,0.3,0.1,0.4c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.4l0,0.2l0,0.2
        c0,0.4-0.1,0.9-0.2,1.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1c-0.2,0.1-0.3,0.4-0.3,0.7
        c0,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0,0.2,0,0.4c0,0.2,0,0.3,0,0.5c0,0.1,0.1,0.4,0.1,0.4c0,0,0,0,0,0c0,0,0,0,0,0.1
        c0.1,0.1,0.1,0.2,0.2,0.3l0,0c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0,0,0.1,0s0,0.1,0,0.1l-0.2,0.2c0,0.1,0,0.1-0.1,0.1l-0.1,0.4
        c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0s0,0,0,0c0,0.1-0.1,0.1-0.1,0.1l0,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0.1,0.2
        c0.3,0.1,0.1,0.2,0.6,0.2c0,0,0.1,0,0.1,0l0,0l0.9,0c0.1,0,0,0,0.1,0c0.2,0,0.4-0.1,0.3-0.4c-0.1-0.2-0.2-0.2-0.3-0.3
        c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.2-0.1-0.2c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.2,0-0.5-0.1-0.7c0,0,0,0-0.1,0
        c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6l0,0c0.1-0.5,0.2-1.1,0.3-1.6c0-0.2-0.1-0.1,0.1-0.2c0.1-0.1,0.4-0.3,0.5-0.4
        c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.5-1.1,0.5-1.3c0,0,0-0.1,0-0.1c0,0,0.1-0.4,0.1-0.5c0-0.4,0.1-0.9,0-1.3c0-0.1,0-0.2,0-0.3
        c0,0,0.1,0,0.1-0.1s0-0.1,0-0.2c0-0.1,0-0.3,0-0.4s0-0.7,0-0.8c0.1,0,0.1,0,0.2,0c0.3-0.1,0.2-0.1,0.2-0.3
        c-0.1-0.4-0.2-1.3-0.2-1.8v-0.3c0-0.1,0-0.1,0-0.1c0.1-0.5,0.3-0.9,0.5-1.4c0-0.1,0.1-0.4,0.2-0.4c0,0,0,0,0.1,0.1
        c0.1,0.1,0.3,0.5,0.4,0.6c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.3,0.5c0.2,0.1,0.4,0.2,0.6,0.2c0.1-0.1,0.3-0.5,0.3-0.7
        c0-0.1,0-0.2,0-0.3c0,0-0.1-0.3-0.1-0.4c0-0.1-0.1-0.1,0.1-0.2c0,0,0,0,0,0s0,0,0,0c-0.1-0.1-0.1-0.2-0.1-0.2
        c-0.3-0.4-0.5-0.9-0.6-1.4c-0.2-0.5-0.3-0.5-0.8-0.5c-0.3,0-0.7-0.1-0.9-0.3c-0.1,0-0.1-0.1-0.2-0.2c-0.1-0.2,0.2-0.5,0.3-0.7
        c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.4c0-0.1,0-0.3,0-0.4c0-0.2-0.1-0.4-0.3-0.6
        c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.3,0.1-0.4,0.1
        c-0.2,0.1-0.3,0.2-0.4,0.4c-0.2,0.3-0.1,0.4-0.1,0.6c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0,0,0,0.1c0,0.1,0,0.1,0.1,0.2
        c0.1,0.3,0.2,0.2,0.2,0.4c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4-0.2,0.6c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1
        c-0.3,0-0.4,0-0.6,0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1,0.1,0.3,0.1,0.5
        c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.4-0.2,0.6
        c0,0.2-0.1,0.4-0.1,0.7c0,0.2-0.1,0.5-0.1,0.7c0,0.2-0.2,0.3-0.1,0.6c0,0.1,0,0.2,0.1,0.2c0.1,0,0.2,0.1,0.3,0.1c0,0,0-0.1,0.1-0.1
        c0.1,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1-0.1s0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0-0.1,0.3,0.1,0.2c0-0.1,0-0.1,0.1-0.2
        c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2,0-0.3c0.2-0.2,0.3-0.5,0.4-0.8
        c0.1-0.2,0-0.2,0.2-0.3c0.1-0.1,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.1,0.1
        c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0,0.7c0,0.3,0.1,0.6,0.1,0.9c0,0.4-0.1,0.7-0.3,1l-0.2,0.3c-0.2,0.3-0.3,0.6-0.5,0.9
        c0,0,0,0.1-0.1,0.1c0,0.1,0.3,0.2,0.4,0.3c0,0.1,0,0.2,0,0.3C96.7,564.5,96.7,565.1,96.7,565.1"
        />
      </g>
    </svg>
  ),
  runwayRunInactive: (className, styles) => (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 86.9 24"
      className={className}
      style={{ ...styles, enableBackground: 'new 0 0 86.9 24' }}
    >
      <g id="Group_24" transform="translate(-64.7 -552.509)">
        <g id="Group_22" transform="translate(64.7 552.509)">
          <path
            id="Path_25"
            style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#ccc' }}
            d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,6.5l0.2,1.8L12.8,9
			l-0.2-1.8L19.5,6.5z M4.5,17.6l-1-9.4L5.3,8l1,9.4L4.5,17.6z M10.5,17l-3.1-4.1l-0.8,1.1l-0.3-2.4l2.9-3.9l2.6-0.3l-3.1,4.1
			l4.4,5.3L10.5,17z M13,11l4.8-0.5l0.2,1.8l-4.8,0.5L13,11z M13.6,16.6l-0.2-1.8l6.9-0.8l0.2,1.8L13.6,16.6z"
          />
        </g>
        <g id="Group_23" transform="translate(105.056 555.813)">
          <path
            id="Path_26"
            style={{ fill: '#ccc' }}
            d="M0,7.6V0h2.2C2.9,0,3.5,0.2,4,0.5c0.4,0.4,0.7,1,0.6,1.5c0,0.4-0.1,0.9-0.3,1.2
			C4,3.6,3.6,3.9,3.2,4c0.1,0.1,0.3,0.2,0.4,0.3C3.7,4.4,3.9,4.6,4,4.8l1.9,2.8H4.6l-1.3-2C3,5.2,2.7,4.8,2.3,4.5
			C2,4.3,1.7,4.2,1.4,4.2H1.1v3.4L0,7.6z M1.1,3.3H2c0.4,0,0.8-0.1,1.1-0.3c0.5-0.5,0.5-1.3,0-1.8C2.8,1,2.4,0.9,2,0.9H1.1V3.3z"
          />
          <path
            id="Path_27"
            style={{ fill: '#ccc' }}
            d="M6.3,0h1.1v4.4c0,0.3,0,0.7,0.1,1c0,0.2,0.1,0.4,0.3,0.5c0.2,0.3,0.5,0.5,0.8,0.6
			c0.3,0.1,0.7,0.2,1.1,0.2c0.6,0,1.1-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.4V0h1.1v4.9c0,0.8-0.3,1.6-0.9,2.1
			c-0.7,0.6-1.5,0.8-2.4,0.8C9,7.8,8.5,7.7,8,7.5C7.5,7.3,7.1,7,6.8,6.6C6.6,6.3,6.5,6.1,6.4,5.8C6.3,5.3,6.3,4.9,6.3,4.4L6.3,0z"
          />
          <path
            id="Path_28"
            style={{ fill: '#ccc' }}
            d="M14.5,7.6V0h0.9l5,5.9V0h1.1v7.6h-1l-5-5.9v5.9H14.5z"
          />
          <path
            id="Path_29"
            style={{ fill: '#ccc' }}
            d="M25,7.7L22.1,0h1.1l1.9,5.2L27.2,0h0.7l2,5.2L31.8,0h1.1l-2.9,7.7h-0.2l-2.3-5.9l-2.3,5.9H25z"
          />
          <path
            id="Path_30"
            style={{ fill: '#ccc' }}
            d="M32.5,7.6L35.8,0h0.8l3.4,7.6h-1.1l-1-2.2h-3.3l-1,2.2H32.5z M35,4.4h2.4l-1.2-2.8L35,4.4z"
          />
          <path
            id="Path_31"
            style={{ fill: '#ccc' }}
            d="M42.3,7.6V3.8L39.4,0h1.3l2.2,2.9L45.2,0h1.3l-3.1,3.9v3.8L42.3,7.6z"
          />
          <path
            id="Path_32"
            style={{ fill: '#ccc' }}
            d="M0,18.4v-7.6h2.2c0.6,0,1.3,0.2,1.8,0.5c0.4,0.4,0.7,1,0.6,1.5c0,0.4-0.1,0.9-0.3,1.2
			c-0.3,0.3-0.7,0.6-1.1,0.7c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.2,0.3,0.4,0.4,0.6l1.9,2.8H4.6l-1.3-2c-0.3-0.4-0.6-0.8-1-1.2
			C2,15.1,1.7,15,1.4,15H1.1v3.4L0,18.4z M1.1,14.1H2c0.4,0,0.8-0.1,1.1-0.3c0.5-0.5,0.5-1.3,0-1.8c-0.3-0.2-0.8-0.3-1.2-0.3H1.1
			V14.1z"
          />
          <path
            id="Path_33"
            style={{ fill: '#ccc' }}
            d="M6.3,10.7h1.1v4.4c0,0.3,0,0.7,0.1,1c0,0.2,0.1,0.4,0.3,0.5c0.2,0.3,0.5,0.5,0.8,0.6
			c0.3,0.1,0.7,0.2,1.1,0.2c0.6,0,1.1-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.4v-4.9h1.1v4.9c0,0.8-0.3,1.6-0.9,2.1
			c-0.7,0.6-1.5,0.8-2.4,0.8c-0.5,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.9c-0.2-0.2-0.3-0.5-0.4-0.8c-0.1-0.4-0.1-0.9-0.1-1.3
			L6.3,10.7z"
          />
          <path
            id="Path_34"
            style={{ fill: '#ccc' }}
            d="M14.5,18.4v-7.6h0.9l5,5.9v-5.9h1.1v7.6h-1l-5-5.9v5.9H14.5z"
          />
        </g>
        <path
          id="Path_35"
          style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#ccc' }}
          d="M96.7,565.1c0,0,0,0.1,0,0.1s0,0.1,0,0.1c0,0.2,0,0.5,0,0.7l0,0.1c0,0,0,0,0.1,0c0.1,0,0,0,0,0
		c0.1,0,0.1,0,0.2,0c0,0,0.1,0.7,0.1,0.7c0,0.1,0.1,0.3,0.1,0.4c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.4l0,0.2l0,0.2
		c0,0.4-0.1,0.9-0.2,1.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1c-0.2,0.1-0.3,0.4-0.3,0.7
		c0,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0,0.2,0,0.4c0,0.2,0,0.3,0,0.5c0,0.1,0.1,0.4,0.1,0.4c0,0,0,0,0,0c0,0,0,0,0,0.1
		c0.1,0.1,0.1,0.2,0.2,0.3l0,0c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0,0,0.1,0s0,0.1,0,0.1l-0.2,0.2c0,0.1,0,0.1-0.1,0.1l-0.1,0.4
		c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0s0,0,0,0c0,0.1-0.1,0.1-0.1,0.1l0,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0.1,0.2
		c0.3,0.1,0.1,0.2,0.6,0.2c0,0,0.1,0,0.1,0l0,0l0.9,0c0.1,0,0,0,0.1,0c0.2,0,0.4-0.1,0.3-0.4c-0.1-0.2-0.2-0.2-0.3-0.3
		c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.2-0.1-0.2c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.2,0-0.5-0.1-0.7c0,0,0,0-0.1,0
		c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6l0,0c0.1-0.5,0.2-1.1,0.3-1.6c0-0.2-0.1-0.1,0.1-0.2c0.1-0.1,0.4-0.3,0.5-0.4
		c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.5-1.1,0.5-1.3c0,0,0-0.1,0-0.1c0,0,0.1-0.4,0.1-0.5c0-0.4,0.1-0.9,0-1.3c0-0.1,0-0.2,0-0.3
		c0,0,0.1,0,0.1-0.1s0-0.1,0-0.2c0-0.1,0-0.3,0-0.4s0-0.7,0-0.8c0.1,0,0.1,0,0.2,0c0.3-0.1,0.2-0.1,0.2-0.3
		c-0.1-0.4-0.2-1.3-0.2-1.8v-0.3c0-0.1,0-0.1,0-0.1c0.1-0.5,0.3-0.9,0.5-1.4c0-0.1,0.1-0.4,0.2-0.4c0,0,0,0,0.1,0.1
		c0.1,0.1,0.3,0.5,0.4,0.6c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.3,0.5c0.2,0.1,0.4,0.2,0.6,0.2c0.1-0.1,0.3-0.5,0.3-0.7
		c0-0.1,0-0.2,0-0.3c0,0-0.1-0.3-0.1-0.4c0-0.1-0.1-0.1,0.1-0.2c0,0,0,0,0,0s0,0,0,0c-0.1-0.1-0.1-0.2-0.1-0.2
		c-0.3-0.4-0.5-0.9-0.6-1.4c-0.2-0.5-0.3-0.5-0.8-0.5c-0.3,0-0.7-0.1-0.9-0.3c-0.1,0-0.1-0.1-0.2-0.2c-0.1-0.2,0.2-0.5,0.3-0.7
		c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.4c0-0.1,0-0.3,0-0.4c0-0.2-0.1-0.4-0.3-0.6
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.3,0.1-0.4,0.1
		c-0.2,0.1-0.3,0.2-0.4,0.4c-0.2,0.3-0.1,0.4-0.1,0.6c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0,0,0,0.1c0,0.1,0,0.1,0.1,0.2
		c0.1,0.3,0.2,0.2,0.2,0.4c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4-0.2,0.6c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1
		c-0.3,0-0.4,0-0.6,0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1,0.1,0.3,0.1,0.5
		c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.4-0.2,0.6
		c0,0.2-0.1,0.4-0.1,0.7c0,0.2-0.1,0.5-0.1,0.7c0,0.2-0.2,0.3-0.1,0.6c0,0.1,0,0.2,0.1,0.2c0.1,0,0.2,0.1,0.3,0.1c0,0,0-0.1,0.1-0.1
		c0.1,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1-0.1s0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0-0.1,0.3,0.1,0.2c0-0.1,0-0.1,0.1-0.2
		c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2,0-0.3c0.2-0.2,0.3-0.5,0.4-0.8
		c0.1-0.2,0-0.2,0.2-0.3c0.1-0.1,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.1,0.1
		c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0,0.7c0,0.3,0.1,0.6,0.1,0.9c0,0.4-0.1,0.7-0.3,1l-0.2,0.3c-0.2,0.3-0.3,0.6-0.5,0.9
		c0,0,0,0.1-0.1,0.1c0,0.1,0.3,0.2,0.4,0.3c0,0.1,0,0.2,0,0.3C96.7,564.5,96.7,565.1,96.7,565.1"
        />
      </g>
    </svg>
  ),
  nightRunInactive: (className, styles) => (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 73.9 24"
      className={className}
      style={{ ...styles, enableBackground: 'new 0 0 73.9 24' }}
    >
      <g id="Group_27" transform="translate(-64.7 -699.299)">
        <g id="Group_25" transform="translate(64.7 699.299)">
          <path
            id="Path_36"
            style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#ccc' }}
            d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,6.5l0.2,1.8L12.8,9
			l-0.2-1.8L19.5,6.5z M4.5,17.6l-1-9.4L5.3,8l1,9.4L4.5,17.6z M10.5,17l-3.1-4.1l-0.8,1.1l-0.3-2.4l2.9-3.9l2.6-0.3l-3.1,4.1
			l4.4,5.3L10.5,17z M13,11l4.8-0.5l0.2,1.8l-4.8,0.5L13,11z M13.6,16.6l-0.2-1.8l6.9-0.8l0.2,1.8L13.6,16.6z"
          />
        </g>
        <g id="Group_26" transform="translate(105.056 702.208)">
          <path
            id="Path_37"
            style={{ fill: '#ccc' }}
            d="M0,7.8V0.1H1l5,5.9V0.1h1.1v7.6h-1l-5-5.9v5.9L0,7.8z"
          />
          <path
            id="Path_38"
            style={{ fill: '#ccc' }}
            d="M8.7,7.8V0.1h1.1v7.6L8.7,7.8z"
          />
          <path
            id="Path_39"
            style={{ fill: '#ccc' }}
            d="M18,4v3.2c-0.5,0.2-0.9,0.4-1.4,0.5c-0.4,0.1-0.9,0.2-1.3,0.2c-0.4,0-0.9-0.1-1.3-0.2
			c-1-0.3-1.9-1-2.4-1.9c-0.3-0.6-0.5-1.2-0.5-1.9c0-1,0.4-2,1.2-2.8c0.4-0.4,0.9-0.7,1.4-0.9C14.2,0.1,14.8,0,15.3,0
			c0.4,0,0.9,0.1,1.3,0.2c0.5,0.1,0.9,0.3,1.3,0.5v1.2c-0.4-0.2-0.9-0.4-1.4-0.6C16.2,1.1,15.8,1,15.3,1c-0.8,0-1.6,0.3-2.2,0.8
			C12,3,12,4.8,13.1,6c0,0,0,0,0,0c0.6,0.6,1.4,0.9,2.2,0.8c0.3,0,0.5,0,0.8-0.1c0.3-0.1,0.6-0.1,0.8-0.3V5h-1.4V4L18,4z"
          />
          <path
            id="Path_40"
            style={{ fill: '#ccc' }}
            d="M19.4,7.8V0.1h1.1v3.3h4.4V0.1H26v7.6h-1.1V4.4h-4.4v3.3L19.4,7.8z"
          />
          <path
            id="Path_41"
            style={{ fill: '#ccc' }}
            d="M29.7,7.8V1.1h-2.8v-1h6.7v1h-2.8v6.6L29.7,7.8z"
          />
          <path
            id="Path_42"
            style={{ fill: '#ccc' }}
            d="M0,18.5v-7.6h2.2c0.6,0,1.3,0.2,1.8,0.5c0.4,0.4,0.7,1,0.6,1.5c0,0.4-0.1,0.9-0.3,1.2
			c-0.3,0.3-0.7,0.6-1.1,0.7c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.2,0.3,0.4,0.4,0.6l1.9,2.8H4.6l-1.3-2c-0.2-0.4-0.6-0.8-1-1.2
			c-0.3-0.2-0.6-0.3-0.9-0.3H1.1v3.4L0,18.5z M1.1,14.2H2c0.4,0,0.8-0.1,1.1-0.3c0.5-0.5,0.5-1.3,0-1.8c-0.3-0.2-0.8-0.3-1.2-0.3
			H1.1V14.2z"
          />
          <path
            id="Path_43"
            style={{ fill: '#ccc' }}
            d="M6.3,10.9h1.1v4.4c0,0.3,0,0.7,0.1,1c0,0.2,0.1,0.4,0.3,0.5c0.2,0.3,0.5,0.5,0.8,0.6
			c0.3,0.1,0.7,0.2,1.1,0.2c0.6,0,1.1-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.4v-4.9h1.1v4.9c0,0.8-0.3,1.6-0.9,2.1
			c-0.7,0.6-1.5,0.8-2.4,0.8c-0.5,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.9c-0.2-0.2-0.3-0.5-0.4-0.8c-0.1-0.4-0.1-0.9-0.1-1.3
			L6.3,10.9z"
          />
          <path
            id="Path_44"
            style={{ fill: '#ccc' }}
            d="M14.5,18.5v-7.6h0.9l5,5.9v-5.9h1.1v7.6h-1l-5-5.9v5.9L14.5,18.5z"
          />
        </g>
        <path
          id="Path_45"
          style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#ccc' }}
          d="M96.7,711.9c0,0,0,0.1,0,0.1s0,0.1,0,0.1c0,0.2,0,0.5,0,0.7l0,0.1c0,0,0,0,0.1,0c0.1,0,0,0,0,0
		c0.1,0,0.1,0,0.2,0c0,0,0.1,0.7,0.1,0.7c0,0.1,0.1,0.3,0.1,0.4c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.4l0,0.2l0,0.2
		c0,0.4-0.1,0.9-0.2,1.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1c-0.2,0.1-0.3,0.4-0.3,0.7
		c0,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0,0.2,0,0.4c0,0.2,0,0.3,0,0.5c0,0.1,0.1,0.4,0.1,0.4s0,0,0,0c0,0,0,0,0,0.1
		c0.1,0.1,0.1,0.2,0.2,0.3l0,0c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0,0,0.1,0s0,0.1,0,0.1l-0.2,0.2c0,0.1,0,0.1-0.1,0.1l-0.1,0.4
		c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0s0,0,0,0c0,0.1-0.1,0.1-0.1,0.1l0,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0.1,0.2
		c0.3,0.1,0.1,0.2,0.6,0.2c0,0,0.1,0,0.1,0l0,0l0.9,0c0.1,0,0,0,0.1,0c0.2,0,0.4-0.1,0.3-0.4c-0.1-0.2-0.2-0.2-0.3-0.3
		c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.2-0.1-0.2c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.2,0-0.5-0.1-0.7c0,0,0,0-0.1,0
		c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6l0,0c0.1-0.5,0.2-1.1,0.3-1.6c0-0.2-0.1-0.1,0.1-0.2c0.1-0.1,0.4-0.3,0.5-0.4
		c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.5-1.1,0.5-1.3c0,0,0-0.1,0-0.1c0,0,0.1-0.4,0.1-0.5c0-0.4,0.1-0.9,0-1.3c0-0.1,0-0.2,0-0.3
		c0,0,0.1,0,0.1-0.1s0-0.1,0-0.2c0-0.1,0-0.3,0-0.4s0-0.7,0-0.8c0.1,0,0.1,0,0.2,0c0.3-0.1,0.2-0.1,0.2-0.3
		c-0.1-0.4-0.2-1.3-0.2-1.8v-0.3c0-0.1,0-0.1,0-0.1c0.1-0.5,0.3-0.9,0.5-1.4c0-0.1,0.1-0.4,0.2-0.4c0,0,0,0,0.1,0.1
		c0.1,0.1,0.3,0.5,0.4,0.6c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.3,0.5c0.2,0.1,0.4,0.2,0.6,0.2c0.1-0.1,0.3-0.5,0.3-0.7
		c0-0.1,0-0.2,0-0.3c0,0-0.1-0.3-0.1-0.4c0-0.1-0.1-0.1,0.1-0.2c0,0,0,0,0,0s0,0,0,0c-0.1-0.1-0.1-0.2-0.1-0.2
		c-0.3-0.4-0.5-0.9-0.6-1.4c-0.2-0.5-0.3-0.5-0.8-0.5c-0.3,0-0.7-0.1-0.9-0.3c-0.1,0-0.1-0.1-0.2-0.2c-0.1-0.2,0.2-0.5,0.3-0.7
		c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.4c0-0.1,0-0.3,0-0.4c0-0.2-0.1-0.4-0.3-0.6
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.3,0.1-0.4,0.1
		c-0.2,0.1-0.3,0.2-0.4,0.4c-0.2,0.3-0.1,0.4-0.1,0.6c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0,0,0,0.1c0,0.1,0,0.1,0.1,0.2
		c0.1,0.3,0.2,0.2,0.2,0.4c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4-0.2,0.6c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1
		c-0.3,0-0.4,0-0.6,0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1,0.1,0.3,0.1,0.5
		c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.4-0.2,0.6
		c0,0.2-0.1,0.4-0.1,0.7c0,0.2-0.1,0.5-0.1,0.7c0,0.2-0.2,0.3-0.1,0.6c0,0.1,0,0.2,0.1,0.2c0.1,0,0.2,0.1,0.3,0.1c0,0,0-0.1,0.1-0.1
		c0.1,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1-0.1s0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0-0.1,0.3,0.1,0.2c0-0.1,0-0.1,0.1-0.2
		c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.1-0.2,0-0.3c0.2-0.2,0.3-0.5,0.4-0.8
		c0.1-0.2,0-0.2,0.2-0.3c0.1-0.1,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.1,0.1
		c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0,0.7c0,0.3,0.1,0.6,0.1,0.9c0,0.4-0.1,0.7-0.3,1l-0.2,0.3c-0.2,0.3-0.3,0.6-0.5,0.9
		c0,0,0,0.1-0.1,0.1c0,0.1,0.3,0.2,0.4,0.3c0,0.1,0,0.2,0,0.3C96.7,711.3,96.7,711.9,96.7,711.9"
        />
      </g>
    </svg>
  ),
  h2oMineralInactive: (className, styles) => (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 74.9 24" className={className} style={{...styles, enableBackground:'new 0 0 74.9 24'}}>
<g id="Group_41" transform="translate(-64.7 -835.776)">
	<g id="Group_38" transform="translate(64.7 835.776)">
		<path id="Path_58" style={{ fillRule: 'evenodd', clipRule: 'evenodd', fill: '#ccc' }} d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,6.5l0.2,1.8L12.8,9
			l-0.2-1.8L19.5,6.5z M4.5,17.6l-1-9.4L5.3,8l1,9.4L4.5,17.6z M10.5,17l-3.1-4.1l-0.8,1.1l-0.3-2.4l2.9-3.9l2.6-0.3l-3.1,4.1
			l4.4,5.3L10.5,17z M13,11l4.8-0.5l0.2,1.8l-4.8,0.5L13,11z M13.6,16.6l-0.2-1.8l6.9-0.8l0.2,1.8L13.6,16.6z"/>
	</g>
	<g id="Group_39" transform="translate(95.023 838.686)">
		<path id="Path_59" style={{fill:'#ccc'}} d="M0,7.8V0.1h1.1v3.3h4.4V0.1h1.1v7.6H5.5V4.4H1.1v3.3H0z"/>
		<path id="Path_60" style={{fill:'#ccc'}} d="M10.2,3.9c0-0.5,0.1-1,0.3-1.5c0.2-0.5,0.5-0.9,0.9-1.3c0.4-0.4,0.8-0.7,1.3-0.9
			c0.5-0.2,1-0.3,1.6-0.3c0.5,0,1.1,0.1,1.6,0.3c1.5,0.6,2.5,2.1,2.5,3.7c0,0.5-0.1,1-0.3,1.5c-0.2,0.5-0.5,0.9-0.9,1.3
			c-0.4,0.4-0.8,0.7-1.3,0.9c-0.5,0.2-1,0.3-1.6,0.3c-0.5,0-1.1-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.3-0.9C10.7,6,10.2,5,10.2,3.9
			L10.2,3.9z M11.4,3.9c0,0.4,0.1,0.8,0.2,1.1C11.8,5.4,12,5.7,12.3,6c0.3,0.3,0.6,0.5,0.9,0.6c0.7,0.3,1.5,0.3,2.2,0
			c0.4-0.1,0.7-0.4,0.9-0.6c0.3-0.3,0.5-0.6,0.6-0.9c0.3-0.7,0.3-1.5,0-2.2c-0.2-0.4-0.4-0.7-0.6-1c-0.3-0.3-0.6-0.5-0.9-0.6
			C15.1,1.1,14.7,1,14.3,1c-0.4,0-0.8,0.1-1.1,0.2c-0.4,0.2-0.7,0.4-1,0.6c-0.3,0.3-0.5,0.6-0.6,0.9C11.5,3.2,11.4,3.6,11.4,3.9
			L11.4,3.9z"/>
		<path id="Path_61" style={{fill:'#ccc'}} d="M0,18.5v-7.6h0.9l2.7,3.2l2.7-3.2h0.9v7.6H6.3v-6l-2.6,3.1l-2.6-3.1v6H0z"/>
		<path id="Path_62" style={{fill:'#ccc'}} d="M9.1,18.5v-7.6h1.1v7.6H9.1z"/>
		<path id="Path_63" style={{fill:'#ccc'}} d="M11.8,18.5v-7.6h0.9l5,5.9v-5.9h1.1v7.6h-1l-5-5.9v5.9H11.8z"/>
		<path id="Path_64" style={{fill:'#ccc'}} d="M20.5,18.5v-7.6h4.6v1h-3.5v2.3H25v1h-3.4v2.4h3.6v1L20.5,18.5z"/>
		<path id="Path_65" style={{fill:'#ccc'}} d="M26.6,18.5v-7.6h2.2c0.6,0,1.3,0.2,1.8,0.5c0.4,0.4,0.7,1,0.6,1.5c0,0.4-0.1,0.9-0.3,1.2
			c-0.3,0.3-0.7,0.6-1.1,0.7c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.2,0.3,0.4,0.4,0.6l1.9,2.8h-1.3l-1.3-2c-0.3-0.4-0.6-0.8-1-1.2
			c-0.3-0.2-0.6-0.3-0.9-0.3h-0.3v3.4L26.6,18.5z M27.7,14.2h0.9c0.4,0,0.8-0.1,1.1-0.3c0.5-0.5,0.5-1.3,0-1.8
			c-0.3-0.2-0.8-0.3-1.2-0.3h-0.9L27.7,14.2z"/>
		<path id="Path_66" style={{fill:'#ccc'}} d="M31.8,18.5l3.3-7.6H36l3.4,7.6h-1.1l-1-2.2h-3.3l-1,2.2H31.8z M34.4,15.3h2.4l-1.2-2.8
			L34.4,15.3z"/>
		<path id="Path_67" style={{fill:'#ccc'}} d="M39.9,18.5v-7.6H41v6.7h3.6v1H39.9z"/>
	</g>
	<g id="Group_40" transform="translate(102.35 843.914)">
		<path id="Path_68" style={{fill:'#ccc'}} d="M0,4.5c0.2-0.3,0.5-0.7,0.8-1c0.3-0.4,0.5-0.6,0.5-0.6C1.4,2.6,1.6,2.3,1.7,2
			c0.1-0.2,0.1-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6C1.5,0.7,1.3,0.6,1.1,0.6c-0.2,0-0.3,0.1-0.5,0.1C0.4,0.9,0.3,1,0.1,1.2V0.4
			c0.2-0.1,0.3-0.2,0.5-0.3C0.8,0,1,0,1.2,0c0.4,0,0.7,0.1,1,0.4c0.2,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.3,1.1
			c-0.3,0.5-0.7,1-1.1,1.5h1.7v0.6L0,4.5z"/>
	</g>
</g>
</svg>
  )
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/ui/src/component/icon/icons.js